const getUnlocalizedSpecificationItem = (serverSpecificationItems) => {
  return serverSpecificationItems?.find((item) => item.locale === "en")?.value;
};
export {
  getUnlocalizedSpecificationItem
};
//# sourceMappingURL=get-unlocalized-specification-item.js.map
